import styled from "styled-components";

export const ContactForm = styled.div`
  .invalid {
    color: ${(props) => `${props.theme.colors.terracotta}`};
    font-size: 0.875rem;
    margin-top: 10px;
  }
`;
